import Swiper from 'swiper'
export default function instagramApi() {
	jQuery.fn.FCInstagram.accessData = {
		accessToken:
			'IGAAL3H5X8I5BBZAGJ3VF82dmIxcEZA2T21TOG51QW9OVllXQi1xc0FyTWdIRjc3NTUyTW1FQ2tDUzNGT2sySmpXVXl5U29Sdjh3ZA29lcHdUUzA2aVZAabzZApLU5mSE5SY0dxc2s2S2dDdmdVXzBVOEVLWGF1M09Xbmtoal8xd3BRQQZDZD',
		// Token
	}

	$('#instafeed').FCInstagram({
		max: 10, // A number between 1 and 25 of photos to show. Default: 9
		autoplay: false, // Set autoplay video: true/false. Default: false
		complete: function () {
			// A callback function to execute after the display of the photos.
			console.log('completed')

			const instaItems = document.querySelectorAll('#instafeed a')
			const instaWrapper = document.querySelector('#instafeed')

			const htmlSlide = [...instaItems]
				.map((item) => {
					return `
                <div  class="swiper-slide">
                        <span style="visibility:hidden">-</span>
                        <div>
                            ${item.outerHTML}    
                            <div class="content">
                            <svg>
                                <use xlink:href="#icon_instagram_white"></use>
                            </svg>
                            <span class="text-caps-2">Ver no instagram</span>
                            </div>
                        </div>
                </div>
                `
				})
				.join('')

			instaWrapper.innerHTML = `          
            <div class="swiper swiper-acompanhe-nos" style="display: grid; width:100%;">
                <div class="swiper-wrapper">
                ${htmlSlide}
                </div>
            </div>
            `

			const swiperAcompanhe = new Swiper('.swiper-acompanhe-nos', {
				lazy: true,
				slidesPerView: 'auto',
				spaceBetween: 8,
				centeredSlides: true,
				centeredSlidesBounds: true,
			})
		},
	})
}
